export enum PaymentLogo {
  AdyenEPS = 'adyenEPS',
  Amex = 'amex',
  Bancontact = 'bancontact',
  Belfius = 'belfius',
  CarteBancaire = 'carteBancaire',
  Ideal = 'ideal',
  Invoice = 'invoice',
  Kbccbc = 'kbccbc',
  Mastercard = 'mastercard',
  Paypal = 'paypal',
  Secure = 'secure',
  Visa = 'visa',
}
